import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TmmsaisineSharedModule } from '../../shared';
import { InputTextModule, DataTableModule, ButtonModule, DialogModule, MultiSelectModule } from 'primeng/primeng';


import {
    MasterService,
    MasterPopupService,
    MasterComponent,
    MasterDetailComponent,
    MasterDialogComponent,
    MasterPopupComponent,
    MasterDeletePopupComponent,
    MasterDeleteDialogComponent,
    MasterReferentielComponent,
    masterRoute,
    masterPopupRoute,
} from './';
import {MasterDetailReferentielComponent} from './master-detail-referentiel.component';

let ENTITY_STATES = [
    ...masterRoute,
    ...masterPopupRoute,
];

@NgModule({
    imports: [
        TmmsaisineSharedModule,
        InputTextModule, DataTableModule, ButtonModule, DialogModule, MultiSelectModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MasterComponent,
        MasterDetailComponent,
        MasterDialogComponent,
        MasterDeleteDialogComponent,
        MasterPopupComponent,
        MasterDeletePopupComponent,
        MasterReferentielComponent,
        MasterDetailReferentielComponent
    ],
    entryComponents: [
        MasterComponent,
        MasterDialogComponent,
        MasterPopupComponent,
        MasterDeleteDialogComponent,
        MasterDeletePopupComponent,
        MasterReferentielComponent,
        MasterDetailReferentielComponent
    ],
    providers: [
        MasterService,
        MasterPopupService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TmmsaisineMasterModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master.module.ts